import React, { useContext } from 'react';
import {
	GameCategoriesContext,
	IGameCategoriesContext,
} from 'modules/Entertainment/Games/GameCategories/gameCategoriesState/gameCategoriesContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IGameCategoriesContext>(GameCategoriesContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
